import { render, staticRenderFns } from "./CreateNewPartner.vue?vue&type=template&id=09f3c80e&"
import script from "./CreateNewPartner.vue?vue&type=script&lang=js&"
export * from "./CreateNewPartner.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewPartner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VRow,VTextField})
